const app = {
  name: 'SEKAR',
  desc: 'Portal Serikat Karyawan Hutama Karya',
  fullname: 'Serikat Karyawan',
  company: 'PT Hutama Karya (Persero)',
  guide: null,
  // guide: 'https://drive.google.com/drive/folders/1jBWqGf9Px1PNv_vv4saIr1tGjyUb9PsV?usp=sharing',
  site: null,
  code: 'sekar-hk',
  logo: {
    sm: './static/img/logo/240x240.png',
    md: './static/img/logo/480x480.png',
    lg: './static/img/logo/720x720.png',
    global: './static/img/logo/logo-landing.png'
  },
  server: {
    stagging: '/api/',
    development: 'https://sekar.berinovasi.top/api/',
    production: '/api/',
    demo: 'https://sekar.berinovasi.top/api/'
  },
  wbs: {
    development: 'https://sekar-aduan-hk.berinovasi.top/api/',
    production: 'https://sekar-aduan-hk.berinovasi.top/api/'
  },
  sso: {
    stagging: 'https://sekar.berinovasi.top/api/',
    development: 'https://sekar.berinovasi.top/api/',
    production: '?????',
    demo: 'https://sekar.berinovasi.top/api/'
  },
  download: {
    android: 'https://play.google.com/store/',
    ios: 'https://www.apple.com/id/app-store/'
  },
  options: {
    allowRegister: false,
    forgetPassword: true,
    autofill: false,
    myAction: false,
    asideRight: false,
    sso: true
  }
}

// =========================================================
// File CUSTOM Variable SCSS
// static\assets\sass\components\_variables.demo.scss
// =========================================================

export default app



// WEBPACK FOOTER //
// ./src/config.js